const state = {
  companyReportSummary: {},
  companyReportProfileId: null,
  companyReportReleaseDisplay: null,
};

const mutations = {
  SET_COMPANY_REPORT_SUMMARY: (state, companyReportSummary) => {
    state.companyReportSummary = companyReportSummary;
  },
  SET_COMPANY_REPORT_PROFILE_ID: (state, companyReportProfileId) => {
    state.companyReportProfileId = companyReportProfileId;
  },
  SET_COMPANY_REPORT_RELEASE_DISPLAY: (state, companyReportReleaseDisplay) => {
    state.companyReportReleaseDisplay = companyReportReleaseDisplay;
  },
};

const getters = {
  companyReportSummary: (state) => state.companyReportSummary,
  companyReportProfileId: (state) => state.companyReportProfileId,
  companyReportReleaseDisplay: (state) => state.companyReportReleaseDisplay,
};

const companyReport = {
  state,
  getters,
  mutations,
};

export default companyReport;
